import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";

export const WebhookShape = {
  postback_url: Yup.string().label("URL").url().required(),
  headers: Yup.string().label("Custom HTTP Headers").max(2048).optional(),
  use_legacy_payload: Yup.boolean().label("Legacy Payload").required(),
};

export interface WebhookInput {
  postback_url: string;
  headers?: string;
  use_legacy_payload: boolean;
}

export const WebhookDefaults = {
  postback_url: "https://",
};

yupResolver<WebhookInput>(Yup.object().shape(WebhookShape));
